import { Component, inject } from '@angular/core';
import { ConsultaDemandaService } from './consulta-demanda.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppModule } from '../../../app-module';
import { AlertComponent } from '../../../commons/components/alert/alert.component';
import { AlertService } from '../../../commons/components/alert/alert.service';
import { LoaderComponent } from '../../../commons/components/loader/loader.component';
import { BaseReponseGeneric } from '../../../commons/class/BaseReponseGeneric.interface';
import { AcuseDTO } from '../../../commons/class/Acuse.class';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogComponent } from '../../../commons/components/dialog/dialog.component';

@Component({
    selector: 'oaj-consulta-demanda-itx',
    templateUrl: 'consulta-demanda.component.html',
    imports: [AppModule, AlertComponent, LoaderComponent],
    styleUrls: ['./consulta-demanda.component.css'],
    providers: [ConsultaDemandaService]
})

export class ConsultaDemandaComponent {
    private service: ConsultaDemandaService = inject(ConsultaDemandaService);
    private alertService: AlertService = inject(AlertService);
    private modalService: NgbModal = inject(NgbModal);
    private fb: FormBuilder = inject(FormBuilder);
    constructor() {
        this.formConsulta = this.fb.group({
            'folio': [{ value: null, disabled: false }, [Validators.required, Validators.pattern("^[0-9]*$"),]],
        })
    }

    formConsulta: FormGroup;
    submitted = false;
    loading = false;
    sMensajeLoad = 'Buscando';


    /**
     * Funcion para manejar el envio del formulario de consulta de demanda, se valida que se hayan llenado todos los campos requeridos y que el folio contenga solo numeros, se hace una consulta al servicio para obtener la demanda dependiendo del folio ingresado, se muestra una modal con el detalle de la demanda obtenida, se muestra un mensaje de error si no se cumplen las validaciones o si ocurre un error durante la consulta de la demanda
     */
    buscar() {
        this.submitted = true;
        if (!this.formConsulta.valid) {
            this.formConsulta.markAllAsTouched();
            this.alertService.error('Validar formulario', { autoClose: true, keepAfterRouteChange: false });
            return;
        }
        this.loading = true;
        this.service.getDemandaByfolio(this.formConsulta.controls['folio'].value)
            .subscribe((r: BaseReponseGeneric<AcuseDTO>) => {

                const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
                modalRef.componentInstance.data = { id: 2, obj: r.data, Title: r.data == null ? "Advertencia" : "Detalle de la solicitud" };
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                modalRef.componentInstance.response.subscribe((receivedEntry: any) => {
                    //Bloque no usado
                });

                this.loading = false;
            });
    }
}